import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

const LOGIN_BG =
  "https://static.prod-images.emergentagent.com/jobs/12472dcf-0127-436b-9ae3-742c43cb1cce/images/16e25da5ee1a0fb6ba17b9957f7e9d400f15fb131f815103b2bef95e90fc833c.png";

function splitBrand(name) {
  const parts = (name || "").trim().split(/\s+/);
  if (parts.length >= 2) return [parts.slice(0, -1).join(" "), parts.slice(-1)[0].toUpperCase()];
  return [name || "Griffin Consultancy", "PULSE"];
}

export default function Login() {
  const location = useLocation();
  const error = location.state?.error;
  const [settings, setSettings] = useState({
    portal_name: "Griffin Consultancy Pulse",
    portal_tagline: "Internal Portal",
    logo_file_id: null,
  });

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data || {})).catch(() => {});
  }, []);

  const [primary, secondary] = splitBrand(settings.portal_name);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="login-page">
      {/* Left: Auth */}
      <div className="flex items-center justify-center px-6 py-12 bg-white">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-3 mb-12">
            <img
              src={`${process.env.PUBLIC_URL || ""}/branding/griffin-logo.png`}
              alt={primary}
              className="h-10 w-10 rounded-sm object-contain bg-white"
              data-testid="brand-logo"
            />
            <div>
              <div className="text-sm font-semibold tracking-tight" style={{ fontFamily: "Outfit" }}>
                {primary}
              </div>
              <div className="text-[10px] gc-label">{secondary || settings.portal_tagline}</div>
            </div>
          </div>

          <div className="space-y-3 mb-10">
            <div className="gc-label">Secure Sign In</div>
            <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-[#0f172a]" style={{ fontFamily: "Outfit" }}>
              Welcome back.
            </h1>
            <p className="text-sm text-slate-500 leading-relaxed">
              Access restricted to verified <span className="font-mono-data text-[#0a2540]">@griffinconsultancy.in</span> employees.
              Sign in with your Google Workspace account to continue.
            </p>
          </div>

          {error && (
            <div
              className="mb-6 p-3 border border-red-200 bg-red-50 text-red-800 text-sm rounded-sm"
              data-testid="login-error"
            >
              {error}
            </div>
          )}

          <Button
            onClick={handleGoogleLogin}
            className="w-full h-12 bg-[#0a2540] hover:bg-[#0f2f50] text-white rounded-sm font-medium"
            data-testid="login-google-button"
          >
            <svg className="mr-3" width="18" height="18" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A10.99 10.99 0 0 0 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.06H2.18A10.99 10.99 0 0 0 1 12c0 1.77.42 3.45 1.18 4.94l3.66-2.84z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/>
            </svg>
            Continue with Google Workspace
          </Button>

          <div className="mt-8 pt-6 border-t border-slate-200">
            <div className="gc-label mb-2">Need access?</div>
            <p className="text-xs text-slate-500">
              Contact your admin to be invited. Only invited employees with
              a verified <span className="font-mono-data">@griffinconsultancy.in</span> address can sign in.
            </p>
          </div>
        </div>
      </div>

      {/* Right: image */}
      <div className="hidden lg:block relative overflow-hidden bg-[#0a2540]">
        <img
          src={LOGIN_BG}
          alt={primary}
          className="absolute inset-0 w-full h-full object-cover opacity-90"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0a2540]/40 to-[#0a2540]/10" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="gc-label text-white/70">Established Practice</div>
          <h2 className="mt-2 text-3xl font-semibold tracking-tight" style={{ fontFamily: "Outfit" }}>
            Accounting & Tax<br />Compliance — Engineered.
          </h2>
          <p className="mt-3 text-sm text-white/70 max-w-md">
            Manage clients, projects, tasks, compliance calendars, and your team — all from one quiet, precise workspace.
          </p>
        </div>
      </div>
    </div>
  );
}
